// FormThree.js
import React, { useCallback, useEffect, useState } from "react";
import { Field, formValueSelector, reduxForm } from "redux-form";
import validate from "./validate";
import { useSelector } from "react-redux";
import {
	PopoverBody,
	PopoverHeader,
	Spinner,
	UncontrolledPopover
} from "reactstrap";
import renderField from "./renderOptionField";

// const events = [
// 	{
// 		_id: "667dad14996e70a66d98c52d",
// 		title:
// 			"A5M - Conceito da deficiência biopsicossocial: direitos das pessoas com deficiência com foco na autonomia e independência",
// 		description:
// 			"08:00- 09:00 - Conceito da deficiência biopsicossocial: direitos das pessoas com deficiência com foco na autonomia e independência - \tDra. Indyara de Araujo Moraes – Brasília/DF <br>\n09:00 -12:00 - SUB PALESTRAS <br>\nConvenção Internacional dos Direitos das Pessoas com Deficiência: Implementação no Brasil sob a ótica da Assistência Social - Dra. Indyara de Araujo Moraes – Brasília/DF <br>\nA crescente longevidade das pessoas com deficiência: estamos preparados? Uma conversa sobre sucessão familiar e temas relacionados\tEsp. Ricardo Pimenta – Itaúna/MG <br>\nResidências inclusivas: políticas públicas e levantamentos dos serviços existentes no Brasil - Dr. Éverton Luís Pereira - Brasília/DF"
// 	},
// 	{
// 		_id: "667f02c27a475f999577f9fe",
// 		title:
// 			"B5M - Tecnologia assistiva, outros auxílios tecnológicos e processos para o viver independente: autonomia, independência e manutenção das capacidades funcionais das Pessoas com Deficiência",
// 		description:
// 			"08:00 - 09:00 - Tecnologia assistiva, outros auxílios tecnológicos e processos para o viver independente: autonomia, independência e manutenção das capacidades funcionais das Pessoas com Deficiência - Drª Débora Liberato – Natal/RN <br>\nMESA REDONDA–TECNOLOGIA ASSISTIVA <br>\n09:00 - 10:00 - Desenvolvimento de conhecimento e às tecnologias para apoiar a vida, o bem estar e o cuidado à pessoa idosa com deficiência: gerontecnologia. - Dr. Johannes Doll – Porto Alegre/RS <br>\n10:00 - 11:00 - Ateliê de Jogos Digitais - Drª Adriana Gomes Alves – Itajaí/SC <br>\n11:00 - 12:00 - RELATOS DE EXPERIÊNCIA <br>"
// 	},
// 	{
// 		_id: "667f017f7a475f999577f99c",
// 		title: "A7V - FORMALIZAÇÃO DOS TERMOS DE CONVÊNIOS E PRESTAÇÃO DE CONTAS.",
// 		description:
// 			"13:30 - 17:00 - FORMALIZAÇÃO DOS TERMOS DE CONVÊNIOS E PRESTAÇÃO DE CONTAS. -  Esp. Patrick Basso - FCEE - São José/SC <br>\nEsp. Zadir Teresinha Machado Ferreira - Florianópolis/SC <br>"
// 	}
// ];

const FormSeven = props => {
	const {
		handleSubmit,
		pristine,
		submitting,
		previousPage,
		onFormSixSubmit,
		change
		// events
	} = props;

	const state = useSelector(state => state);

	const selector = formValueSelector("certificate_emission");

	const loading = selector(state, "loading");

	const events = selector(state, "events");

	const event = selector(state, "event");

	const handleNextClick = useCallback(
		async e => {
			e.preventDefault();

			const nextEvent =
				events?.[events.findIndex(e => e._id === event._id) + 1];

			console.log("nextEvent", nextEvent);
			if (nextEvent) {
				change("event", nextEvent);

				document.querySelector(".account__sub_logo")?.scrollIntoView();
			} else {
				handleSubmit(onFormSixSubmit);
			}
		},
		[event, events]
	);

	const handlePrevious = e => {
		e.preventDefault();

		const previousEvent =
			events?.[events.findIndex(e => e._id === event._id) - 1];

		if (previousEvent) {
			change("event", previousEvent);

			document.querySelector(".account__sub_logo")?.scrollIntoView();
		} else {
			previousPage();
		}
	};

	useEffect(() => {
		change("event", events?.[0]);
	}, [events]);

	const options = [
		{
			value: "goodDidacticMaterial",
			label: "Utilizou material didático adequado, atualizado e de qualidade?"
		},
		{
			value: "understandableExposition",
			label: "Demonstrou clareza na exposição dos temas abordados?"
		},
		{
			value: "easyLearning",
			label:
				"Utilizou estratégias de ensino que facilitaram a sua aprendizagem?"
		},
		{
			value: "interestAwakened",
			label:
				"Despertou o seu interesse, utilizando exemplos práticos e ilustrativos?"
		},
		{
			value: "questionsAnswered",
			label: "Mostrou-se disposto a esclarecer suas dúvidas e questionamentos?"
		},
		{
			value: "knowledgeDemonstrated",
			label:
				"Demonstrou possuir domínio e conhecimento atualizado e de qualidade?"
		}
	];

	if (!event) return null;

	return (
		<div>
			<form className="form" onSubmit={handleNextClick}>
				<div className="form__form-group">
					<div className="flex-center">
						<h3 className="account__sub-title text-center">
							Avalie as palestras da seguinte sala
						</h3>
						<h3 className="account__title">{event.title}</h3>
						<span
							id={`event_${event._id}`}
							style={{
								paddingLeft: 8,
								paddingRight: 8,
								cursor: "pointer",
								color: "#6bb567",
								minWidth: 70
							}}
						>
							Confia a programação
						</span>
						<UncontrolledPopover
							placement="bottom"
							target={`event_${event._id}`}
							trigger="legacy"
						>
							<PopoverHeader>Programação</PopoverHeader>
							<PopoverBody
								dangerouslySetInnerHTML={{ __html: event.description }}
							></PopoverBody>
						</UncontrolledPopover>
					</div>
					<br />
					{options.map(option => (
						<div key={option.value}>
							<div
								className="form__form-group-field"
								// style={{ justifyContent: "space-around" }}
							>
								<div className="form__form-group">
									<label style={{ fontWeight: "bold", fontSize: "16px" }}>
										{option.label}
									</label>
									<div
										className="form__form-group-field"
										style={{
											display: "flex",
											justifyContent: "center",
											// alignItems: "center",
											marginTop: "10px"
										}}
									>
										<Field
											name={`${event._id}[${option.value}]`}
											component={renderField}
										/>
									</div>
								</div>
							</div>
						</div>
					))}
				</div>

				<div className="account__btn__group">
					<button
						type="button"
						className="btn btn-primary account__btn account__btn--small"
						onClick={handlePrevious}
					>
						Voltar
					</button>
					<button
						type="submit"
						className="btn btn-primary account__btn account__btn--small"
						disabled={pristine || submitting || loading}
					>
						{loading ? (
							<Spinner type="grow" size="sm" color="dark" />
						) : (
							"Próximo"
						)}
					</button>
				</div>
			</form>
		</div>
	);
};

export default reduxForm({
	form: "certificate_emission",
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate: v => validate(v, 7)
})(FormSeven);
